import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/index-page/logo.webp")